import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useAuth } from '../../context/AuthContext';
import { USER_ROLES } from '../../constants/userRoles';
import { HOME_CONTENT_BY_ROLE } from './homeConfig';
import './Home.css';

function Home() {
  const { user } = useAuth();
  const role = user?.rol ?? USER_ROLES.PACIENTE;
  const content = HOME_CONTENT_BY_ROLE[role] ?? HOME_CONTENT_BY_ROLE[USER_ROLES.PACIENTE];
  const displayName = user?.nombre ?? user?.nombreUsuario ?? 'usuario';

  return (
    <div className="home">
      <section className="home__hero" aria-labelledby="home-greeting">
        <p className="home__eyebrow">SweetMedical</p>
        <h1 id="home-greeting" className="home__greeting">
          Hola, <span className="home__name">{displayName}</span>
        </h1>
        <p className="home__role-badge" aria-label={`Rol: ${content.roleLabel}`}>
          {content.roleLabel}
        </p>
        <p className="home__intro">{content.intro}</p>
      </section>

      <section className="home__features" aria-labelledby="home-features-title">
        <h2 id="home-features-title" className="home__features-title">
          ¿Cómo podemos ayudarte hoy?
        </h2>
        <ul
          className="home__grid"
          style={{ '--home-cols': content.features.length }}
        >
          {content.features.map(({ Icon, title, description, to, comingSoon }) => (
            <li key={title} className="home__card-wrapper">
              {to && !comingSoon ? (
                <Link to={to} className="home__card home__card--link">
                  <FeatureCardContent
                    Icon={Icon}
                    title={title}
                    description={description}
                    actionable
                  />
                </Link>
              ) : (
                <article
                  className="home__card home__card--disabled"
                  aria-label={`${title} — próximamente disponible`}
                >
                  <FeatureCardContent
                    Icon={Icon}
                    title={title}
                    description={description}
                    comingSoon={comingSoon}
                  />
                </article>
              )}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

function FeatureCardContent({ Icon, title, description, actionable, comingSoon }) {
  return (
    <>
      <span className="home__card-icon" aria-hidden="true">
        <Icon />
      </span>
      <div className="home__card-body">
        <h3 className="home__card-title">{title}</h3>
        <p className="home__card-description">{description}</p>
        {comingSoon && (
          <span className="home__card-badge">Próximamente</span>
        )}
      </div>
      {actionable && (
        <span className="home__card-arrow" aria-hidden="true">
          <ArrowForwardIcon />
        </span>
      )}
    </>
  );
}

export default Home;
